<div [@openClose]="isOpen ? 'open' : 'closed'" #layoutContainer class="layout-container">
    <ng-content></ng-content>
</div>